import React, { Component } from "react";
import { createClassNames, connectSearchBox } from "react-instantsearch-dom";
import PropTypes from "prop-types";

const cx = createClassNames("CurrentRefinements");

class Query extends Component {
    static propTypes = {
        currentRefinement: PropTypes.string,
        refine: PropTypes.func.isRequired
    };

    handleClick = () => {
        this.props.refine();
    };

    render() {
        const { currentRefinement } = this.props;

        if (!currentRefinement) {
            return null;
        }

        return (
            <div className={cx("")}>
                <ul className={cx("list")}>
                    <li className={cx("item")}>
                        <span className={cx("label")}>
                            &lsquo;
                            {currentRefinement}
                            &rsquo;
                        </span>
                        <span className={cx("category")}>
                            <button
                                className={cx("delete")}
                                onClick={this.handleClick}
                            >
                                x
                            </button>
                        </span>
                    </li>
                </ul>
            </div>
        );
    }
}

export default connectSearchBox(Query);



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/Query.js